
import moment from 'moment'
import { mapState } from 'vuex'
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  name: 'MaterialCardTable',
  components: {
    VueQRCodeComponent,
    PreviewFile: () => import('@/components/modal/PreviewFile'),
  },
  inheritAttrs: false,
  props: {
    url: {
      type: String,
      default: '',
    },
    fetchOnMount: {
      type: Boolean,
      default: true,
    },
    showjumlahbukubesar: {
      type: Boolean,
      default: false,
    },
    showjumlahneraca: {
      type: Boolean,
      default: false,
    },
    activetextbutton: {
      type: String,
      default: null,
    },
    showcreatewithidbutton: {
      type: Boolean,
      default: false,
    },
    urlcreate: {
      type: String,
      default: '/',
    },
    viewqr: {
      type: Boolean,
      default: false,
    },
    viewqrurl: {
      type: String,
      default: '/',
    },
    urlexport: {
      type: String,
      default: '/',
    },
    urlgenerate: {
      type: String,
      default: '/',
    },
    urlwagenerate: {
      type: String,
      default: '/',
    },
    urlupload: {
      type: String,
      default: '/',
    },
    urlimport: {
      type: String,
      default: '/',
    },
    urlrekening: {
      type: String,
      default: '/',
    },
    urlbackbutton: {
      type: String,
      default: '/',
    },
    urlgeneraterekening: {
      type: String,
      default: '/',
    },
    urlsubdata: {
      type: String,
      default: '/',
    },
    color: {
      type: String,
      default: 'secondary',
    },
    title: {
      type: String,
      default: undefined,
    },
    customtitleleft: {
      type: String,
      default: undefined,
    },
    customtitleright: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: undefined,
    },
    fields: {
      type: Array,
      default: null,
    },
    fieldsdetail: {
      type: Array,
      default: null,
    },
    subdatatext: {
      type: String,
      default: null,
    },
    showprint: {
      type: Boolean,
      default: false,
    },
    showsubdata: {
      type: Boolean,
      default: false,
    },
    scanqrwa: {
      type: Boolean,
      default: false,
    },
    urlscanqrwa: {
      type: String,
      default: '/',
    },
    showaction: {
      type: Boolean,
      default: false,
    },
    showcreatebutton: {
      type: Boolean,
      default: false,
    },
    showcheckduplicate: {
      type: Boolean,
      default: false,
    },
    showeditbutton: {
      type: Boolean,
      default: false,
    },
    showdeletebutton: {
      type: Boolean,
      default: false,
    },
    showrekeningbutton: {
      type: Boolean,
      default: false,
    },
    showrekeningbuttondetail: {
      type: Boolean,
      default: false,
    },
    showsantributton: {
      type: Boolean,
      default: false,
    },
    showgeneraterekeningbutton: {
      type: Boolean,
      default: false,
    },
    showfilterbutton: {
      type: Boolean,
      default: false,
    },
    showbackbutton: {
      type: Boolean,
      default: false,
    },
    showactivebutton: {
      type: Boolean,
      default: false,
    },
    showstatusbutton: {
      type: Boolean,
      default: false,
    },
    isfiltered: {
      type: Boolean,
      default: false,
    },
    isuploaded: {
      type: Boolean,
      default: false,
    },
    isexported: {
      type: Boolean,
      default: false,
    },
    isimported: {
      type: Boolean,
      default: false,
    },
    showgeneratecode: {
      type: Boolean,
      default: false,
    },
    showwageneratecode: {
      type: Boolean,
      default: false,
    },
    showpagination: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Boolean,
      default: false,
    },
    filterdatas: {
      type: Object,
      default: null,
    },
    variablefilter: {
      type: String,
      default: null,
    },
    exportfilename: {
      type: String,
      default: null,
    },
    exportmimetype: {
      type: String,
      default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    exportfileextension: {
      type: String,
      default: 'xlsx',
    },
    topheader: {
      type: Boolean,
      default: false,
    },
    dataTopHeader: {
      type: Array,
      default: null,
    },
    showsppcard: {
      type: Function,
      default: null,
    },
    customNominal: {
      type: Boolean,
      default: false,
    },
    showfullcode: {
      type: Boolean,
      default: false,
    },
    perpage: {
      type: Number,
      default: 10,
    },
    showbtnoption: {
      type: Boolean,
      default: true,
    },
    showsummary: {
      type: Boolean,
      default: false,
    },
    showsummarynominatif: {
      type: Boolean,
      default: false,
    },
    showsummaryspp: {
      type: Boolean,
      default: false,
    },
    urluservendor: {
      type: String,
      default: '/',
    },
    showuservendorbutton: {
      type: Boolean,
      default: false,
    },
    urlunpaid: {
      type: String,
      default: '/',
    },
    showbtntagihanspp: {
      type: Boolean,
      default: false,
    },
    urldelete: {
      type: String,
      default: '/',
    },
    showqr: {
      type: Boolean,
      default: false,
    },
    urlactivate: {
      type: String,
      default: '/',
    },
    showactivesettdatafix: {
      type: Boolean,
      default: false,
    },
    generateinvoice: {
      type: Boolean,
      default: false,
    },
    payinvoice: {
      type: Boolean,
      default: false,
    },
    updatelimitrekening: {
      type: Boolean,
      default: false,
    },
    showdetailbutton: {
      type: Boolean,
      default: false,
    },
    urldetail: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      isBusy: false,
      search: '',
      items: [],
      total_debit: 0,
      total_kredit: 0,
      saldo_awal: 0,
      saldo_akhir: 0,
      totalnominatif: 0,
      total_saldo_awal: 0,
      total_saldo_akhir: 0,
      firstLoad: false,
      modalQR: {
        show: false,
        url: null,
        title: null,
        class: 'qr_iframe',
        limit: 10,
        page: 1,
        count: 0,
        paginate: false,
      },
      modalQRLembaga: {
        id: null,
        show: false,
        url: null,
        title: null,
        class: 'qr_iframe',
      },
      meta: {
        count: 0,
        limit: 10,
        next_page: 1,
        page: 1,
        previous_page: 1,
        total_pages: 1,
      },
      pageoptions: [5, 10, 20, 50],
      isCheckedAll: [],
      checkbox: [],
      modalLimitRek: {
        id: null,
        show: false,
        title: 'Ubah Limit Transaksi Rekening',
      },
      form: {
        max_transaction: '',
      },
      nominal: {
        max_transaction: '',
      },
      modalFile: {
        show: false,
        url: '',
      },
      summarySpp: {
        total_paid: 0,
        total_unpaid: 0,
      },
    }
  },
  computed: {
    ...mapState(['dataSummary', 'dataCheckbox']),
    hasOffset() {
      return this.$slots.header || this.$slots.offset || this.title || this.text
    },
    styles() {
      if (!this.hasOffset) return null
      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset * 2}px`,
      }
    },
  },
  watch: {
    showSummary() {
      this.coltotal = this.showSummary
    },
    checkbox() {
      if (this.items.length > 0) {
        const count = this.items.filter((v) => v.is_transfered !== 'success').length
        this.isCheckedAll = count === this.checkbox.length ? ['all'] : []

        this.$store.commit(
          'SET_DATA_CHECKBOX',
          this.items
            .filter((f) => this.checkbox.includes(f.id))
            .map((f) => ({ id: f.id, amount: f.amount, details: f.details }))
        )
      }
    },
  },
  mounted() {
    if (this.fetchOnMount) {
      this.getData()
    }
  },
  methods: {
    decodeHtml(input) {
      const doc = new DOMParser().parseFromString(input, 'text/html')
      return doc.documentElement.textContent || ''
    },
    changeCheckedAll() {
      if (this.isCheckedAll.length > 0) {
        const checked = []
        this.items.forEach((x) => {
          if (x.is_transfered !== 'success') checked.push(x.id)
        })
        this.checkbox = [...new Set(checked)]
      } else {
        this.checkbox = []
      }
    },
    showModol() {
      alert('tes')
    },
    setAjaran(year, month) {
      if (!year || !month || year === 0 || month === 0) return '-'

      const formattedMonth = month.toString().padStart(2, '0')

      return moment(`${year}-${formattedMonth}-01`)
        .locale('id')
        .format('MMMM YYYY')
        .replace(/^\w/, (c) => c.toUpperCase())
    },
    printData() {
      const w = window.open()
      w.document.write(this.$refs.PrintData.$el.innerHTML)
      w.document.close()
      w.setTimeout(function () {
        w.print()
      }, 1000)
    },
    async generateCode() {
      await this.$axios
        .get('api/' + this.urlgenerate, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const FILE = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          )
          const docUrl = document.createElement('a')
          docUrl.href = FILE
          docUrl.setAttribute('download', 'kode_aktivasi.xlsx')
          document.body.appendChild(docUrl)
          docUrl.click()
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    async SendWaActivation() {
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan pengiriman kode aktivasi via Whatsapp ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.urlwagenerate)
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Kode Aktivasi Berhasil dikirim ke Wali Santri.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async generateRekening() {
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan Generate Rekening ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.urlgeneraterekening)
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Rekening berhasil digenerate.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async exportExcel() {
      const q = []
      if (this.filterdatas && this.filterdatas !== null && this.filterdatas !== undefined) {
        Object.keys(this.filterdatas).forEach((f) => {
          if (this.filterdatas[f] && this.filterdatas[f] !== undefined) {
            q.push(`${f}=${encodeURIComponent(this.filterdatas[f])}`)
          }
        })
      }
      const qs = q.length ? `?${q.join('&')}` : ''
      const baseName = this.exportfilename || 'export'
      await this.$axios
        .get('api/' + this.urlexport + qs, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const FILE = window.URL.createObjectURL(
            new Blob([res.data], {
              type: this.exportmimetype,
            })
          )
          const docUrl = document.createElement('a')
          docUrl.href = FILE
          docUrl.setAttribute('download', `${baseName}.${this.exportfileextension}`)
          document.body.appendChild(docUrl)
          docUrl.click()
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    async ChangeStatus(id, isActive) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (isActive ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + activeUrl + '/change-status/' + id, {
                is_active: isActive,
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (isActive ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusSettDataFix(item) {
      const url =
        this.urlactivate.replace(':id', item.id) + `?institution_id=${item?.institution_id}`
      await this.$swal
        .fire({
          title: (item.status ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + url, { status: item.status })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (item.status ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusPPOB(id, status) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (status ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .put('api/' + activeUrl + '/change-status/' + id, { status })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (status ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusBooking(id, isActive) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (isActive ? 'non-aktifkan' : 'Implementasikan') + ' lembaga ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + activeUrl + '/change-status/' + id, {
                is_active: isActive,
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (isActive ? 'non-aktifkan' : 'implementasikan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    searchData() {
      this.getData(this.search)
    },
    async getData() {
      const query = [`page=${this.meta.page}`, `limit=${this.meta.limit}`]

      if (this.search && this.search !== undefined) {
        this.meta.page = 1
        query.push(`q=${this.search}`)
      }

      if (this.filterdatas && this.filterdatas !== null && this.filterdatas !== undefined) {
        Object.keys(this.filterdatas).forEach((f) => {
          if (this.filterdatas[f] && this.filterdatas[f] !== undefined) {
            query.push(`${f}=${this.filterdatas[f]}`)
          }
        })
      }

      this.items = []
      this.isBusy = true
      await this.$axios
        .get(`api/${this.url}?${query.join('&')}`)
        .then((res) => {
          // Handle 2 different response formats
          // Format 1: res.data = { meta, data, summary, total }
          // Format 2: res.data.data = { data: [...], summary: {...} }
          let responseData = res.data
          let meta, data, summary, total

          // Check if format 2 (nested data.data)
          if (responseData?.data && typeof responseData.data === 'object' && Array.isArray(responseData.data.data)) {
            data = responseData.data.data
            summary = responseData.data.summary
            meta = responseData.data.meta
            total = responseData.data.total
          } else {
            // Format 1 (direct)
            meta = responseData.meta
            data = responseData.data
            summary = responseData.summary
            total = responseData.total
          }

          if (meta) {
            if (meta.count > 0 && !this.firstLoad) {
              this.firstLoad = true
            }

            this.meta.count = meta.count
          } else this.meta.count = data && data?.length

          if (Array.isArray(data) && data != null) {
            this.items = data
          } else if (!Array.isArray(data) && data != null) {
            this.items = [data]
          } else {
            this.items = []
          }

          if (this.items !== null) {
            if (this.showjumlahbukubesar) {
              // Check summary first (format 2), then fallback to direct (format 1)
              this.total_debit = summary?.total_debit ?? responseData?.total_debit
              this.total_kredit = summary?.total_kredit ?? responseData?.total_kredit
              this.saldo_awal = summary?.saldo_awal ?? responseData?.saldo_awal
              this.saldo_akhir = summary?.saldo_akhir ?? responseData?.saldo_akhir
            }
            if (this.showjumlahneraca) {
              this.total_debit = summary?.total_debit ?? responseData?.total_debit
              this.total_kredit = summary?.total_kredit ?? responseData?.total_kredit
              this.total_saldo_awal = summary?.total_saldo_awal ?? responseData?.total_saldo_awal
              this.total_saldo_akhir = summary?.total_saldo_akhir ?? responseData?.total_saldo_akhir
            }
            if (this.showsummarynominatif) {
              this.totalnominatif = total ?? responseData?.total
            }
            if (this.showsummary) {
              this.total_saldo_awal = total || 0
            }
          } else {
            this.items = []
          }
          if (summary) {
            this.$store.commit('SET_DATA_SUMMARY', summary)
          }
          this.isBusy = false
          this.isCheckedAll = []
          this.$store.commit('SET_DATA_CHECKBOX', [])
        })
        .catch((error) => {
          this.isBusy = false
          this.items = []
          this.$swal.fire({
            icon: 'error',
            title: 'Gagal memuat data',
            text: this.getApiErrorMessage(error, 'Terjadi kesalahan saat memuat data'),
            showConfirmButton: true,
          })
        })
    },
    fetchQRCode() {
      const url = window.location.origin + '/' + this.viewqrurl
      this.modalQR.url = url + `&page=${this.modalQR.page}&limit=${this.modalQR.limit}`
    },
    printQr(id, name) {
      this.modalQR.page = this.meta.page
      this.modalQR.limit = this.meta.limit
      this.modalQR.count = this.meta.count

      let url = window.location.origin + '/' + this.viewqrurl
      if (id !== 'all') {
        url += '&customer_id=' + id
        this.modalQR.class = 'qr_iframe'
        this.modalQR.paginate = false
      } else {
        this.modalQR.class = 'qr_iframe_all'
        url += `&page=${this.modalQR.page}&limit=${this.modalQR.limit}`
        this.modalQR.paginate = true
      }

      this.modalQR.url = url
      this.modalQR.title = name
      this.modalQR.show = true
    },
    printQrLembaga(id, name, type) {
      // const idEncode = btoa(id)
      const url = window.location.origin + '/auth/register-santri?code=' + id
      this.modalQRLembaga.text = type === 'code' ? id : url
      this.modalQRLembaga.id = id
      this.modalQRLembaga.url = url
      this.modalQRLembaga.title = name
      this.modalQRLembaga.show = true
    },
    async checkDuplicate() {
      await this.$swal
        .fire({
          title: 'cek duplikat data ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios.get('api/' + this.url + '/check/duplicate').then((res) => {
              this.$swal
                .fire({
                  icon: 'success',
                  title: 'Data duplikat berhasil dihapus',
                  showConfirmButton: false,
                  timer: 1500,
                })
                .then((res) => {
                  this.getData()
                })
            })
          }
        })
    },
    printDivQR() {
      document.querySelector('#printerDiv > iframe').contentWindow.print()
    },
    printDivQRLembaga() {
      const printContents = document.getElementById('printerDivLembaga').innerHTML
      const originalContents = document.body.innerHTML

      document.body.innerHTML = printContents

      window.print()

      document.body.innerHTML = originalContents
    },
    goToEdit(data) {
      let path = `/${this.url}/${data?.id}`
      if (this.urldelete && this.urldelete === 'setting-data-fix') {
        path += `?institution_id=${data?.institution_id}`
      }
      this.$router.push({ path })
    },
    async deleteData(data) {
      let urldelete = this.url + '/' + data?.id
      if (this.urldelete && this.urldelete !== '/') {
        if (this.urldelete === 'setting-data-fix') {
          urldelete = this.url + '/' + data?.id + `?institution_id=${data?.institution_id}`
        } else {
          urldelete = `${this.urldelete}/${data?.product_detail_id}/${data?.id}`
        }
      }

      await this.$swal
        .fire({
          title: 'hapus data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios.delete('api/' + urldelete).then((res) => {
              this.$swal
                .fire({
                  icon: 'success',
                  title: 'Data berhasil di hapus',
                  showConfirmButton: false,
                  timer: 1500,
                })
                .then((res) => {
                  this.getData()
                })
            })
          }
        })
    },
    async GenerateInvoice(data) {
      this.checkbox = data?.id
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan Generate Invoice ?',
          html: `Total Nominal: ${this.formatRupiah(data?.amount, 'summary')}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.url, {
                transaction: [
                  {
                    institution_id: data?.id,
                    transaction_ids: data?.details?.map((d) => d?.id),
                  },
                ],
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Invoice berhasil digenerate.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async PayInvoice(data) {
      this.checkbox = data?.id
      await this.$swal
        .fire({
          title: 'Apakah akan selesaikan Invoice ini ?',
          html: data?.id,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.url, {
                invoice_code: data?.id,
                is_transfered: 'success',
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Invoice berhasil diselesaikan.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    formatRupiah(value, type) {
      const numericValue = value.toString().replace(/[^\d]/g, '')
      const formatValue = new Intl.NumberFormat('id-ID').format(numericValue)

      if (type === 'summary') return formatValue

      this.nominal[type] = formatValue
      const newVal = this.nominal[type].toString().replace(/[^\d]/g, '')
      this.form[type] = newVal === '0' ? '' : newVal
    },
    showModalLimitRek(data) {
      this.formatRupiah(data?.max_transaction, 'max_transaction')
      this.modalLimitRek.id = data?.id
      this.modalLimitRek.title += ` ${data?.product_name} - ${this.decodeHtml(data?.full_name)}`
      this.modalLimitRek.show = true
    },
    showModalSantri(data) {
      this.$emit('show-santri', data)
    },
    async handleSubmitLimitRek() {
      await this.$axios
        .post(`api/santri/rekening/${this.modalLimitRek.id}/update-limit`, {
          max_transaction: parseInt(this.form?.max_transaction),
        })
        .then((res) => {
          this.$swal
            .fire({
              icon: 'success',
              title: 'Limit Transaksi Rekening berhasil diubah.',
              showConfirmButton: false,
              timer: 1500,
            })
            .then((res) => {
              this.modalLimitRek.id = null
              this.nominal.max_transaction = ''
              this.form.max_transaction = ''
              this.modalLimitRek.show = false
              this.getData()
            })
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    previewFile(file) {
      this.modalFile.url = file
      this.modalFile.show = true
    },
    resetModalFile() {
      this.modalFile.url = ''
      this.modalFile.show = false
    },
  },
}
